import QuestionSlider from "./QuestionSlider";

export default QuestionSlider;
